var _mask, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPresssuit = function SvgPresssuit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "presssuit_svg__a",
    width: 25,
    height: 32,
    x: 5,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5 2h24.636v32H5z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#presssuit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "m25.218 19.073 2.328 9.953.01.033h-.008a22.6 22.6 0 0 1-.38 4.941h-9.46l-.346-1.59h-.1L16.914 34H7.457a22.6 22.6 0 0 1-.37-4.94H7.08l.01-.034 2.317-9.953-.653-6.395L5 11.358V7.793C5 4.594 7.593 2 10.793 2h13.05a5.793 5.793 0 0 1 5.793 5.793v3.565l-3.752 1.32z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "m25.878 12.678-.66 6.395zM8.747 12.713C8.409 9.305 10.787 9.956 10.787 2h1.362s1.12 3.045 2.084 4.629c.965 1.583 3.08 3.318 3.08 6.049v-.01c.005-2.724 2.115-4.458 3.077-6.04C21.355 5.046 22.475 2 22.475 2h1.362c0 7.956 2.38 7.305 2.04 10.713h-.003l-.656 6.36 2.337 9.986s-2.81.145-5.294.792c-1.682.439-3.355 1.754-4.26 2.557-.395.35-.982.35-1.376 0-.906-.803-2.58-2.118-4.26-2.557-2.484-.647-5.285-.792-5.285-.792l2.327-9.986-.66-6.395",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E64909",
    strokeWidth: 2,
    d: "m10.73 28.244 2.095-9.171-.361-3.502M17.321 29.228l-.005-10.155.006-5.254M22.175 15.57l-.361 3.503 2.093 9.17"
  })));
};
export default SvgPresssuit;